import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-select-pickup-date',
    templateUrl: './select-pickup-date.component.html',
    styleUrls: ['./select-pickup-date.component.scss'],
    standalone: false
})
export class SelectPickupDateComponent implements OnInit {
  @Input() type: string;
  @Input() disabled = false;
  selectedDate: any;
  minDate: any = {
    year: 2010,
    month: 1,
    day: 1,
  };
  isDisabled: (date: any, current: { month: number }) => boolean;

  get maxDate() {
    const date = moment().add(28, 'days');
    return new NgbDate(
      Number(date.format('YYYY')),
      Number(date.format('MM')),
      Number(date.format('DD'))
    );
  }

  constructor() {}

  ngOnInit() {
    this.setDates();
  }

  setDates() {
    // Determine how many days to wait before allowing the first pickup
    const deltaDays =
      this.type !== 'batteries'
        ? 1
        : Number(moment().format('HH')) >= 16
        ? 2
        : 1;
  
    const firstPickupDate = moment().add(deltaDays, 'days');
  
    this.minDate = {
      year: Number(firstPickupDate.format('YYYY')),
      month: Number(firstPickupDate.format('MM')),
      day: Number(firstPickupDate.format('DD'))
    };
  
    // Function to disable specific calendar dates
    this.isDisabled = (date: NgbDate, current: { month: number }) => {
      const weekDay = moment(`${date.year}/${date.month}/${date.day}`, 'YYYY/MM/DD').isoWeekday();
      const calendarDate = moment(`${date.year}/${date.month}/${date.day}`, 'YYYY/MM/DD');
  
      const currentDay = moment().day();
      const currentHour = Number(moment().format('HH'));
      const countryCode = localStorage.getItem('country');
  
      // 🔒 1. Disable Monday pickup if it's Friday after 14:00 or on weekends (only for "regular" type)
      if (
        ((currentDay === 5 && currentHour >= 14) || currentDay > 5) &&
        weekDay === 1 &&
        this.type === 'regular'
      ) {
        return true;
      }
  
      // 🔒 2. Holiday blocks (batteries only)
      if (this.type === 'batteries') {
        // BE and NL holidays
        if (
          ['NL', 'BE'].includes(countryCode) &&
          [
            '2026-04-28'
           
          ].some(d => calendarDate.isSame(moment(d, 'YYYY-MM-DD')))
        ) {
          return true;
        }

         if (
          [
            '2026-05-14', '2026-05-15', '2026-05-26'
           
          ].some(d => calendarDate.isSame(moment(d, 'YYYY-MM-DD')))
        ) {
          return true;
        }
  
        // Global end-of-year block (for countries outside BE and NL)
        if (
          !['NL', 'BE'].includes(countryCode) &&
          calendarDate.isSameOrAfter(moment('2024-12-12')) &&
          calendarDate.isSameOrBefore(moment('2025-01-02'))
        ) {
          return true;
        }
  
        // 🔒 3. Block all Mondays for batteries
        if (weekDay === 1) return true;
  
        // ✅ 4. Allow Saturdays for batteries
        if (weekDay === 6) return true;
      }
  
      // 🔒 5. Block weekends (Sunday = 7)
      return weekDay > 5;
    };
  }

  dateChanged() {
    if (typeof this.selectedDate === 'string') {
      const date = moment(this.selectedDate, 'D-M-YYYY');
      const selectedDate: NgbDate = new NgbDate(
        Number(date.format('YYYY')),
        Number(date.format('MM')),
        Number(date.format('DD'))
      );
      this.selectedDate = selectedDate;
    }
  }
}
